import { UiRoutes } from '../lib/constants';

export const PUBLIC_SELF_SERVE_ROUTES = [
  UiRoutes.PUBLIC_KYC_AGREEMENT_SIGN,
  UiRoutes.PUBLIC_UPLOAD_DOCUMENTS,
  UiRoutes.PUBLIC_UPLOAD_COMPANY_DOCUMENTS,
  UiRoutes.PUBLIC_SOFT_REJECTION_UPLOAD_DOCUMENTS,
];

export const isPublicSelfServePath = (pathname?: string): boolean =>
  PUBLIC_SELF_SERVE_ROUTES.includes(pathname || '');
